import React from 'react'
import { StyledMultiCheckBoxForm } from './styled'
import { MultiCheckBoxFormProps } from './types'

export const MultiCheckBoxForm: React.FC<MultiCheckBoxFormProps> = (props: MultiCheckBoxFormProps) => {
  return <StyledMultiCheckBoxForm {...props} />
}
